import { PASSWORD_SPECIAL_CHARS, MIN_PASSWORD_LENGTH } from '@/constants/validators';

export const getPasswordRequirements = () => {
  return [
    {
      re: new RegExp(`.{${MIN_PASSWORD_LENGTH},}`),
      label: `At least ${MIN_PASSWORD_LENGTH} characters`,
    },
    { re: /[0-9]/, label: 'At least one number' },
    { re: /[a-z]/, label: 'At least one lowercase letter' },
    { re: /[A-Z]/, label: 'At least one uppercase letter' },
    { re: PASSWORD_SPECIAL_CHARS, label: `At least one special character` },
    { re: /^\S*$/, label: 'No spaces allowed' },
  ];
};
